import "../styles/cta.css";
function Cta() {
  return (
    <section className="cta">

      <div className="cta-overlay">

        <h2>Ready to Hear Better?</h2>

        <p>
          Schedule your hearing evaluation today and let our experts help you
          find the perfect hearing solution.
        </p>

        <div className="cta-buttons">

          <a href="tel:+919444851663" className="primary-btn">
            Call now
          </a>
        </div>

      </div>

    </section>
  );
}

export default Cta;